<template>
  <el-dialog
    :title="$t(`channel.titles.${isAdd ? 'add' : 'editor'}`)"
    :visible.sync="dialogVisible"
    width="30%"
  >
    <el-row>
      <el-form :model="form" v-bind="formRules">
        <el-form-item :label="$t('channel.label.channelType')" prop="channelType">
          <el-select v-model="form.channelType">
            <el-option v-for="item in channelTypeList" :key="item" :value="item"> </el-option>
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('channel.label.channelCode')"
          prop="channelCode"
        >
          <template v-if="channelCodeList.length>1">
            <el-select v-model="form.channelCode">
              <el-option v-for="item in channelCodeList" :key="item" :value="item"> </el-option>
              <el-option :label="$t('btns.emptyValue')" value=""></el-option>
            </el-select>
          </template>
          <template v-else>
            <el-select v-model="form.channelCode">
              <el-option  :value="channelCodeList[0]"> </el-option>
            </el-select>
          </template>
        </el-form-item>
        <!-- <el-form-item :label="$t('channel.label.serviceType')" prop="serviceType">
          <el-select v-model="form.serviceType" disabled>
            <el-option v-for="item in serviceTypes" :key="item" :value="item" />
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item :label="$t('channel.label.sort')" prop="sort">
          <el-input v-model.trim="form.sort" />
        </el-form-item>
        <el-form-item :label="$t('channel.label.status')" prop="status">
          <el-select v-model="form.status">

            <el-option
              v-for="item in this.statusData"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>

          </el-select>
        </el-form-item>

        <el-form-item :label="$t('channel.label.info')" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
      </el-form>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="warning" @click="handleEmpty()">{{
        $t('btns.empty')
      }}</el-button>
      <el-button size="mini" @click="dialogVisible = false">{{ $t('btns.cancel') }}</el-button>
      <el-button size="mini" type="primary" @click="handleEditor()">{{
        $t('btns.confirm')
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { debounce } from 'lodash';
import { isNumber } from '@/utils/validate';
export default {
  props: ['statusData', 'serviceTypes', 'channelTypeList', 'channelTypeData'],
  data() {
    return {
      dialogVisible: false,
      isAdd: true,
      form: {
        channelCode: '',
        channelType: '',
        name: '',
        // serviceType: '',
        status: 0,
        sort: ''
      }
    };
  },
  computed: {
    channelCodeList() {
      console.log('这里的数据是i。。。', this.channelTypeData, this.form.channelType)
      if (Array.isArray(this.channelTypeData[this.form.channelType])) {
        return this.channelTypeData[this.form.channelType].length > 0 && this.form.channelType !== 'card_pc'
          ? this.channelTypeData[this.form.channelType]
          : [this.form.channelType];
      } else {
        return '';
      }
    }
  },
  created() {
    this.formRules = {
      ref: 'form',
      'label-width': 'auto',
      inline: false,
      size: 'small',
      rules: {
        id: [
          {
            required: true,
            message: this.$t('channel.rules.id'),
            trigger: 'blur'
          }
        ],

        channelCode: [
          {
            required: true,
            message: this.$t('channel.rules.channelCode'),
            trigger: 'change'
          }
        ],
        channelType: [
          {
            required: true,
            message: this.$t('channel.rules.channelType'),
            trigger: 'change'
          }
        ],
        createAcct: [
          {
            required: true,
            message: this.$t('channel.rules.createAcct'),
            trigger: 'blur'
          }
        ],
        createTime: [
          {
            required: true,
            message: this.$t('channel.rules.createTime'),
            trigger: 'change'
          }
        ],
        dayQuota: [
          {
            required: true,
            message: this.$t('channel.rules.dayQuota.empty'),
            trigger: 'blur'
          },
          {
            validator: (rule, value, cb) => {
              if (!isNumber(value)) {
                cb(new Error(this.$t('channel.rules.dayQuota.type')));
              } else if (value <= 0) {
                cb(new Error(this.$t('channel.rules.dayQuota.match')));
              } else {
                cb();
              }
            },
            trigger: 'blur'
          }
        ],
        monthQuota: [
          {
            required: true,
            message: this.$t('channel.rules.monthQuota.empty'),
            trigger: 'blur'
          },
          {
            validator: (rule, value, cb) => {
              if (!isNumber(value)) {
                cb(new Error(this.$t('channel.rules.monthQuota.type')));
              } else if (Number(value) <= Number(this.form.dayQuota)) {
                cb(new Error(this.$t('channel.rules.monthQuota.match')));
              } else {
                cb();
              }
            },
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('channel.rules.name'),
            trigger: 'blur'
          }
        ],

        singleMaxLimit: [
          {
            required: true,
            message: this.$t('channel.rules.singleMaxLimit.empty'),
            trigger: 'blur'
          },
          {
            validator: (rule, value, cb) => {
              if (!isNumber(value)) {
                cb(new Error(this.$t('channel.rules.singleMaxLimit.type')));
              } else if (value < 0) {
                cb(new Error(this.$t('channel.rules.singleMaxLimit.match')));
              } else if (Number(value) < Number(this.form.singleMinLimit)) {
                cb(new Error(this.$t('channel.rules.singleMaxLimit.match1')));
              } else {
                cb();
              }
            },
            trigger: 'blur'
          }
        ],
        singleMinLimit: [
          {
            required: true,
            message: this.$t('channel.rules.singleMinLimit.empty'),
            trigger: 'blur'
          },
          {
            validator: (rule, value, cb) => {
              if (!isNumber(value)) {
                cb(new Error(this.$t('channel.rules.singleMinLimit.type')));
              } else if (value < 0) {
                cb(new Error(this.$t('channel.rules.singleMinLimit.match')));
              } else {
                cb();
              }
            },
            trigger: 'blur'
          }
        ],

        // serviceType: [
        //   {
        //     required: true,
        //     message: this.$t('channel.rules.serviceType'),
        //     trigger: 'change'
        //   }
        // ],
        sort: [
          {
            required: true,
            message: this.$t('channel.rules.sort.empty'),
            trigger: 'blur'
          }
        ]
      }
    };
    this.handleEditor = debounce(this._handleEditor, 300);
  },
  methods: {
    init(row) {
      this.dialogVisible = true;
      if (row) {
        this.isAdd = false;
        // 初始化表单数据

        Object.keys(this.form).forEach((key) => {
          if (row[key] === 0 || row[key]) {
            this.form[key] = row[key];
          }
        });
        this.form.id = row.id;
      }
    },

    /* --------------------------------- 事件驱动函数 --------------------------------- */
    handleEmpty() {
      this.form = {
        channelCode: '',
        channelType: '',
        name: '',
        // serviceType: '',
        status: 0
      };
    },
    _handleEditor() {
      this.$refs.form.validate(
        (valid) =>
          valid &&
          this.$emit(this.isAdd ? 'doConfAdd' : 'doConfUpdate', this.form, () => {
            this.dialogVisible = false;
          })
      );
    }
  }
};
</script>

<style scoped>
 .dialog-footer {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/channel-conf/editor.vue